// src/services/cardService.js
import { collection, addDoc, getDocs, orderBy, query, serverTimestamp, doc, updateDoc, deleteDoc } from "firebase/firestore";
import { db } from "../firebase";

export const saveCard = async (cardData) => {
    try {
        const docRef = await addDoc(collection(db, "cards"), {
            ...cardData,
            createdAt: serverTimestamp()
        });
        return docRef.id;
    } catch (error) {
        console.error("Error saving card:", error);
        return false;
    }
};

export const updateCard = async (cardId, cardData) => {
    try {
        const cardRef = doc(db, "cards", cardId);
        await updateDoc(cardRef, {
            ...cardData,
            updatedAt: serverTimestamp()
        });
        return true;
    } catch (error) {
        console.error("Error updating card:", error);
        return false;
    }
};

export const deleteCard = async (cardId) => {
    try {
        await deleteDoc(doc(db, "cards", cardId));
        return true;
    } catch (error) {
        console.error("Error deleting card:", error);
        return false;
    }
};

// 📥 Fetch cards (newest first)
export const fetchCards = async () => {
    try {
        const q = query(collection(db, "cards"), orderBy("createdAt", "desc"));
        const snapshot = await getDocs(q);

        return snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data(),
            appreciateCount: doc.data().appreciateCount || 0 // ✅ fallback for undefined
        }));
    } catch (error) {
        console.error("Error fetching cards:", error);
        return [];
    }
};

